import { useSelector } from "react-redux";
import MobileActionHeader from "../../../../components/UI/headingsUI/MobileActionHeader";
import { cylinderPredictionFilterOptions } from "../../utils/cylinderFilter.config";
import FilterSearch from "../../../../components/common/FilterSearch";
import NoDataView from "../../../../components/UI/NoDataView";
import PredictionCard from "./PredictionCard";
import CylinderPredictionSearch from "./CylinderPredictionSearch";
import { sortPredictedData } from "../../helpers/sortPredictedData";

const CylinderPredictionLayout = () => {
  const sitesData = useSelector((state) => state.data.data);
  const copyData = useSelector((state) => state.data.copyData);
  const isDataAvailable = sitesData.length > 0;
  const sortedSites = sortPredictedData(sitesData);

  return (
    <>
      <MobileActionHeader title="Cylinders" navigate={"/cylinder/registered"} />
      {copyData.length > 0 && (
        <>
          <div className="md:flex justify-between items-center">
            <div className="flex items-center">
              <div className="max-md:mt-3">
                {" "}
                <FilterSearch categories={cylinderPredictionFilterOptions} />
              </div>
              <CylinderPredictionSearch />
            </div>
          </div>
        </>
      )}
      <div className={`table-container table-height bg-transparent`}>
        {isDataAvailable ? (
          <div className={`font-figtree 2xs:max-md:pt-2 ${"cy-card-grid"}`}>
            {sortedSites.map((item) => (
              <PredictionCard item={item} key={item.station_id} />
            ))}
          </div>
        ) : (
          <NoDataView />
        )}
      </div>
    </>
  );
};

export default CylinderPredictionLayout;
